'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

const allowedValues = (min, max, step, length = 3) => {
    const allowedValues = [];
    const lowerValue = min || 0;
    for (let i = 0; i < length; i++) {
        const value = lowerValue + i * step;
        if (_.isNumber(max) && value > max) {
            break;
        }
        allowedValues.push(value);
    }
    const prefix = !_.isNumber(min)? '..., ': '';
    const postfix = _.isNumber(max) && allowedValues[allowedValues.length-1] < max ?`, ${max}`: '';
    return `${prefix}${allowedValues.join(', ')},...${postfix}`;
};

module.exports = (input, config) => {
    _.defaults(config, {
        required: false,
        min: undefined,
        max: undefined,
        step: 1,
    });

    if (config.required && (_.isNil(input) || input === '')) {
        throw new ParserError(PARSER_ERRORS.REQUIRED);
    }

    if (!_.isNil(input) && input !== '') {
        if (!_.isNumber(input)) {
            throw new ParserError(PARSER_ERRORS.NOT_NUMBER);
        }

        // next checks are performed only if exclusive choice is not present or if exclusive chioice is present and input is different from exclusive choice id
        if (!config.exclusiveChoice || (_.isNumber(config.exclusiveChoice.id) && input !== config.exclusiveChoice.id)) {
            if ((_.isNumber(config.min) && input < config.min)) {
                throw new ParserError(PARSER_ERRORS.MIN_NUMBER, [{min: config.min}]);
            }
            if ((_.isNumber(config.max) && input > config.max)) {
                throw new ParserError(PARSER_ERRORS.MAX_NUMBER, [{max: config.max}]);
            }

            const ratio = _.isNumber(config.min)? (input - config.min) / config.step: input / config.step;
            if (Math.abs(ratio - Math.round(ratio)) > 1e-7) {
                throw new ParserError(PARSER_ERRORS.STEP_NUMBER, [{step: config.step, values: allowedValues(config.min, config.max, config.step)}]);
            }
        }
    }

    return input;
};

